module.exports = __webpack_public_path__ + "static/media/off.4296af66.svg";